import { GetListParams, GetListResult, RaRecord } from "react-admin";
import { postJson } from "../../../utils/api";
import IHandler from "./IHandler";

export default class LearningUsersHandler implements IHandler {
  static route = "/admin/learning/users/search";

  static async getListHandler<RecordType extends RaRecord = any>(
    resource?: string,
    params?: GetListParams
  ): Promise<GetListResult<RecordType>> {
    const page = params?.pagination.page ?? 1;
    const pageSize = params?.pagination.perPage ?? 50;

    const body: { [key: string]: any } = {
      page,
      page_size: pageSize,
    };

    // Pass through search filters
    if (params?.filter) {
      if (params.filter.user_id) body.user_id = params.filter.user_id;
      if (params.filter.first_name) body.first_name = params.filter.first_name;
      if (params.filter.last_name) body.last_name = params.filter.last_name;
      if (params.filter.email) body.email = params.filter.email;
    }

    // Pass through sort params
    if (params?.sort?.field) {
      body.sort_by = params.sort.field;
      body.sort_order = (params.sort.order ?? "DESC").toLowerCase();
    }

    return postJson(this.route, body).then(async (response) => {
      const { data: responseData } = await response.json();
      const users = responseData?.users ?? [];

      const mapped = users.map((u: any) => ({
        ...u,
        id: u.user_id,
      }));

      return {
        data: mapped,
        total: responseData?.total ?? 0,
        pageInfo: {
          hasNextPage: page * pageSize < (responseData?.total ?? 0),
          hasPrevPage: page > 1,
        },
      };
    });
  }
}
